// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2yFd0","form":"Login_form__NGj3z","button":"Login_button__3cv64"};